module.exports = __webpack_public_path__ + "img/aso.f433450a.png";